<template>
  <div pagination max-items="20">
    <!-- Skeleton  -->
    <div v-if="isRequestLoading">
      <div v-for="i in 5" :key="i" class="border border-blue-300 shadow rounded-lg p-4 w-full animate-pulse h-48 my-6"
        style="background: #8080805e"></div>
    </div>

    <div v-if="reviewUserRequest.length > 0 && !isRequestLoading">
      <div v-for="(userRequest, index) in paginatedUserRequest" :key="index">
        <request-card :userRequest="userRequest" :boardsData="boardsData" :index="index" :id="userRequest._id"
          @updateRequestStatus="updateRequestStatus" />
      </div>
    </div>

    <vs-pagination :total="Math.ceil(reviewUserRequest.length / 15)" v-model="currentPage"></vs-pagination>
  </div>
</template>

<script>
import RequestCard from "./components/RequestCard.vue";
export default {
  data() {
    return {
      reviewUserRequest: [],
      isRequestLoading: false,
      currentPage: 1,
      orgId: "",
      boardsData: [{ text: "Board Name", value: "" }],
    };
  },
  components: {
    RequestCard,
  },

  computed: {
    orgData() {
      return this.$store.state.organization.orgData;
    },
    avatarNameGenerator() {
      return this.$store.state.users.avatarNameGenerator;
    },
    paginatedUserRequest() {
      return this.reviewUserRequest.slice(
        15 * (this.currentPage - 1),
        15 * this.currentPage
      );
    },
  },
  watch: {
    orgData() {
      if (this.orgData && this.orgData._id) {
        this.orgId = this.orgData._id;
        this.$store.dispatch("organization/fetchAllEmployees", {
          organizationId: this.orgData._id,
        });
        this.getOrgBoards(this.orgData._id);
        this.getEmployeeRequest(this.orgData._id);
      }
    },
    isRequestLoading(newVal) {
      if (!newVal) {
        if (Object.keys(this.reviewUserRequest).length > 0) {
          this.isRequestLoading = false;
        } else {
          this.isRequestLoading = false;
          this.$router.push({
            name: "org-users",
          });
        }
      }
    },
  },
  methods: {
    getEmployeeRequest(orgId) {
      this.isRequestLoading = true;
      this.$store
        .dispatch("organization/getEmployeeRequest", orgId)
        .then((res) => {
          if (res && res.data && res.data.length > 0) {
            this.reviewUserRequest = res.data;
            this.$route.query.userId
              ? this.findUserAndScroll(this.$route.query.userId)
              : "";
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.isRequestLoading = false;
        });
    },

    updateRequestStatus(user, status, index, boardId) {
      const payload = {
        email: user.email,
        organizationId: this.orgId,
        status: status,
        boardId: boardId,
      };

      this.$store
        .dispatch("organization/requestStatus", payload)
        .then((res) => {
          if (res && res.data) {
            this.reviewUserRequest.splice(index, 1);
            if (status === "ACCEPTED") {
              this.$vs.notify({
                color: "success",
                title: "User request accepted",
                text: "Selected user was added",
              });
            } else {
              this.$vs.notify({
                color: "danger",
                title: "User request declined",
                text: "Selected user was declined",
              });
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    getOrgBoards(orgId) {
      this.$store
        .dispatch("organization/getOrgBoards", orgId)
        .then((res) => {
          if (res && res.data && res.data.length > 0) {
            for (let i = 0; i < res.data.length; i++) {
              let { _id, title } = res.data[i];
              let object = {
                text: title,
                value: _id,
              };
              this.boardsData.push(object);
            }
          }
        })
        .catch((err) => { console.log(err) });
    },

    findUserAndScroll(userId) {
      if (this.reviewUserRequest.length > 0) {
        const userIndex = this.reviewUserRequest.findIndex(
          (user) => user._id === userId.replace(/,/g, "")
        );
        if (userIndex !== -1) {
          this.currentPage = Math.ceil((userIndex + 1) / 15);
          setTimeout(() => {
            // Scroll to the user element
            const userElement = document.getElementById(userId);
            if (userElement) {
              const offset = userElement.offsetTop - 50; // Adjust the offset as needed
              window.scrollTo({ top: offset, behavior: 'smooth' });
            }
          }, 100);
        }
      }
    },
  },
  mounted() {
    if (this.orgData && this.orgData._id) {
      this.$store.dispatch("organization/fetchAllEmployees", {
        organizationId: this.orgData._id,
      });
      this.getOrgBoards(this.orgData._id);
      this.orgId = this.orgData._id;
      this.getEmployeeRequest(this.orgData._id);
    }
  },
};
</script>

<style lang="scss">
.extra__text {
  font-size: 0.95em;
  color: #667085 !important;
  font-weight: 400;
}
</style>
